import { render, staticRenderFns } from "./insuranceIndustry.vue?vue&type=template&id=5c4b01fe"
import script from "./insuranceIndustry.vue?vue&type=script&lang=js"
export * from "./insuranceIndustry.vue?vue&type=script&lang=js"
import style0 from "./insuranceIndustry.vue?vue&type=style&index=0&id=5c4b01fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports